var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

import React, { Component } from 'react';

import { getWidget, getUiOptions, optionsList, retrieveSchema } from "../utils/";

import SchemaLayout from "./SchemaLayout";

var ArrayFieldSelect = function (_Component) {
    _inherits(ArrayFieldSelect, _Component);

    function ArrayFieldSelect() {
        var _temp, _this, _ret;

        _classCallCheck(this, ArrayFieldSelect);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.onSelectChange = function (value) {
            _this.props.onChange(value);
        }, _temp), _possibleConstructorReturn(_this, _ret);
    }

    ArrayFieldSelect.prototype.render = function render() {
        var _props = this.props,
            schema = _props.schema,
            idSchema = _props.idSchema,
            uiSchema = _props.uiSchema,
            formData = _props.formData,
            disabled = _props.disabled,
            readonly = _props.readonly,
            autofocus = _props.autofocus,
            onBlur = _props.onBlur,
            onFocus = _props.onFocus,
            registry = _props.registry,
            rawErrors = _props.rawErrors;

        var items = this.props.formData;
        var widgets = registry.widgets,
            definitions = registry.definitions,
            formContext = registry.formContext;

        var itemsSchema = retrieveSchema(schema.items, definitions, formData);
        var enumOptions = optionsList(itemsSchema);

        var _getUiOptions$enumOpt = _extends({}, getUiOptions(uiSchema), {
            enumOptions: enumOptions
        }),
            _getUiOptions$enumOpt2 = _getUiOptions$enumOpt.widget,
            widget = _getUiOptions$enumOpt2 === undefined ? "select" : _getUiOptions$enumOpt2,
            options = _objectWithoutProperties(_getUiOptions$enumOpt, ["widget"]);

        var Widget = getWidget(schema, widget, widgets);

        var uiOptions = _extends({}, this.props.uiOptions, {
            addable: false
        });

        return React.createElement(
            SchemaLayout,
            _extends({}, this.props, { uiOptions: uiOptions }),
            React.createElement(Widget, {
                id: idSchema && idSchema.$id,
                multiple: true,
                onChange: this.onSelectChange,
                onBlur: onBlur,
                onFocus: onFocus,
                options: options,
                schema: schema,
                value: items,
                disabled: disabled,
                readonly: readonly,
                formContext: formContext,
                autofocus: autofocus,
                rawErrors: rawErrors
            })
        );
    };

    return ArrayFieldSelect;
}(Component);

export default ArrayFieldSelect;